// extracted by mini-css-extract-plugin
export default {"container":"EditProfile_container__O7SnL","subContainer":"EditProfile_subContainer__JDpL6","leftArrow":"EditProfile_leftArrow__xTXCl"};